// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorProductTags = (client) => ({
    /**
     * `GET /vendor/product-tags`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductTags
     * @source packages/modules/b2c-core/src/api/vendor/product-tags/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/product-tags", { method: "GET", query, headers }),
    /**
     * `GET /vendor/product-tags/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductTagById
     * @source packages/modules/b2c-core/src/api/vendor/product-tags/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/product-tags/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=product-tags.js.map